import React from 'react';
import ProductContent from './ProductContent';

// Route wrapper for /product/:id and /p/:id. Hook-free so all logic stays in
// ProductContent; keeping this stable preserves the existing route import.
const ProductDisplayPage: React.FC = () => {
  return <ProductContent />;
};

export default ProductDisplayPage;
